import { StandardChip, StandardChipVariantType } from "../../../../../shared/components/badges/StandardChip"
import { PaymentMethodChannel } from "../../../controlKitchenTypes"

export function ChannelTypeChip({ channel }: { channel?: PaymentMethodChannel }) {
    let variant: StandardChipVariantType

    switch (channel?.type) {
        case "mobile_web":
        case "mobile_app":
            variant = "info"
            break
        case "soft_pos":
            variant = "success"
            break
        default:
            variant = "grey"
    }

    if (!channel?.displayText) return null

    return <StandardChip label={channel?.displayText} variant={variant} placement="table" />
}
